import { render } from "./TagManagementIndex.vue?vue&type=template&id=1b6db2de"
import script from "./TagManagementIndex.vue?vue&type=script&lang=js"
export * from "./TagManagementIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__